/**
 * função que verifica se o parâmetro passado é um número e devolve um booleano
 *
 * @category typing
 */
export const isNumber = (value) => !isNaN(parseFloat(value)) && !isNaN(Number(value));
/**
 * Algoritmo para verificar se os valores sao iguais
 * Polyfill para a função: https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 *
 * @internal
 */
export const objectIs = (x, y) => {
    if (x === y) {
        // Passos 1-5, 7-10
        // Passos 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
    }
    // Passo 6.a: NaN == NaN
    return x !== x && y !== y;
};
